import * as React from 'react';
import { TrendingDown, TrendingUp } from 'lucide-react';
import { cn } from '../lib/utils';
import AnimatedNumber from './AnimatedNumber';

function formatKpiValue(value, format) {
  if (value == null || value === '' || Number.isNaN(value)) return '—';
  if (format === 'percent') return `${value}%`;
  if (format === 'days') return `${value} days`;
  if (typeof value === 'number') return value.toLocaleString('en-US');
  return String(value);
}

function KpiCard({
  label,
  value,
  format = 'number',
  trend,
  trendLabel,
  trendUp,
  className,
}) {
  const showTrend = (trend != null && trend !== '') || (trendLabel != null && trendLabel !== '');
  const hasValue = value != null && value !== '' && !Number.isNaN(Number(value));

  return (
    <div className={cn('clr-kpi-card', className)}>
      <p className="clr-kpi-card__label">
        {label}
      </p>

      <p className="clr-kpi-card__value">
        {hasValue ? (
          <AnimatedNumber value={value} format={format} />
        ) : (
          '—'
        )}
      </p>
      {showTrend && (
        <div
          className={cn(
            'mt-2 flex items-center gap-1 text-sm font-medium',
            trendUp ? 'text-emerald-600' : 'text-amber-600',
          )}
        >
          {trendUp ? (
            <TrendingUp className="clr-icon shrink-0" size={18} />
          ) : (
            <TrendingDown className="clr-icon shrink-0" size={18} />
          )}
          <span>{trendLabel ?? trend}</span>
        </div>
      )}
    </div>
  );
}

export { KpiCard, formatKpiValue };
